import { useRecoilCallback } from 'recoil'
import { selectedItemAtom, itemAtomFamily, editorClipboardAtom } from 'atoms'
import { canvasPageIdAtom } from '@/atoms/_editorAtoms'
import {
  editorTextBoxDocumentsSelector,
  editorTextBoxDraftsAtom,
} from '@/atoms/editorTextBoxAtoms'
import {
  editorTextBoxCurrentDocument,
  isEditorTextBoxItem,
} from '@/utils/editor-text-box/editorTextBoxAdapter'

export const useCopyItemToClipboard = () =>
  useRecoilCallback(
    ({ snapshot, set }) =>
      async () => {
        const selectedItem = await snapshot.getPromise(selectedItemAtom)
        const item = await snapshot.getPromise(itemAtomFamily(selectedItem))

        const copiedItem = { ...item }
        if (isEditorTextBoxItem(item)) {
          const pageId = await snapshot.getPromise(canvasPageIdAtom)
          if (pageId) {
            const [drafts, results] = await Promise.all([
              snapshot.getPromise(editorTextBoxDraftsAtom),
              snapshot.getPromise(editorTextBoxDocumentsSelector(pageId)),
            ])
            copiedItem.editorTextBoxDocument =
              editorTextBoxCurrentDocument({ item, results, drafts }) ??
              undefined
          }
        }
        set(editorClipboardAtom, [copiedItem])
      },
    [],
  )

export default useCopyItemToClipboard
